<a mat-button routerLink="/faq">
    <span fxShow="false" fxShow.gt-sm class="mx-1 uppercase">Aide</span> 
    <mat-icon class="mat-icon-sm caret">headset_mic</mat-icon>
</a>

